import React, { FormEvent, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, LockKeyholeIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function SignIn() {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const password = formData.get('password');
    const email = formData.get('email');
    if (password !== 'password') {
      setError('Incorrect password. For this preview, use “password”.');
      return;
    }
    if (typeof email === 'string') {
      sessionStorage.setItem('manyco.portalEmail', email.trim().toLowerCase());
    }
    navigate('/recovery-portal');
  };
  return <main className="flex min-h-screen w-full items-center justify-center bg-cream px-5 py-10 text-ink sm:px-8" data-id="element-2309" data-mp="8hu1ak4lqxx6">
      <div className="w-full max-w-md" data-id="element-2310" data-mp="3k1xosulhnd5">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-ink/60 transition-colors hover:text-forest" data-id="element-2311" data-mp="3j0jifia8kr7">
          <ArrowLeftIcon className="h-4 w-4" data-id="element-2312" data-mp="2kznkx3qjt5g1" />
          Back to ManyCo.ai
        </Link>

        <section className="mt-8 rounded-3xl border border-ink/10 bg-paper p-7 shadow-xl shadow-ink/5 sm:p-10" aria-labelledby="sign-in-heading" data-id="element-2313" data-mp="2pzi9v1qrjkyg">
          <img src="https://cdn.magicpatterns.com/uploads/oywoASH6Re9P4rztZheujv/ManyCo_ai.svg" alt="ManyCo.ai" className="h-9 w-auto" data-id="element-2314" data-mp="2uws8n801l8yy" />

          <div className="mt-8" data-id="element-2315" data-mp="22aqmqos15ssj">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-forest" data-id="element-2316" data-mp="279acz1dnpqqp">
              <LockKeyholeIcon className="h-3.5 w-3.5" data-id="element-2317" data-mp="2c0iny1umxk5z" />
              Partner portal
            </span>
            <h1 id="sign-in-heading" className="mt-3 font-display text-3xl font-medium tracking-tight" data-id="element-2318" data-mp="1el4oc3jhfhll">
              Welcome back.
            </h1>
            <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-2319" data-mp="1jhv38njjw75f">
              Sign in to view recovery performance, inventory status, and reports.
            </p>
          </div>

          <form className="mt-7 space-y-5" onSubmit={handleSubmit} data-id="element-2320" data-mp="17gwuvabb4evi">
            <div data-id="element-2321" data-mp="1l931o5skl9ia">
              <label htmlFor="email" className="mb-2 block text-sm font-medium text-ink/80" data-id="element-2322" data-mp="1l7i6qf2cfojw">
                Work email
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required placeholder="you@company.com" className="w-full rounded-xl border border-ink/15 bg-cream px-4 py-3 text-sm text-ink placeholder:text-ink/40 outline-none transition focus:border-forest focus:ring-2 focus:ring-forest/15" data-id="element-2323" data-mp="1gc2vluvq06r6" />
            </div>
            <div data-id="element-2324" data-mp="2dw79sjmym3ya">
              <div className="mb-2 flex items-center justify-between gap-3" data-id="element-2325" data-mp="2dvnqozlkp9io">
                <label htmlFor="password" className="text-sm font-medium text-ink/80" data-id="element-2326" data-mp="28xckcyuhlh57">
                  Password
                </label>
                <a href="mailto:hello@manyco.ai?subject=Password%20reset" className="text-xs font-medium text-forest hover:underline" data-id="element-2327" data-mp="3qy506c662uwm">
                  Forgot password?
                </a>
              </div>
              <input id="password" name="password" type="password" autoComplete="current-password" required aria-describedby="password-hint" className="w-full rounded-xl border border-ink/15 bg-cream px-4 py-3 text-sm text-ink outline-none transition focus:border-forest focus:ring-2 focus:ring-forest/15" data-id="element-2328" data-mp="3hxoz19cwbzux" />
              <p id="password-hint" className="mt-2 text-xs text-ink/45" data-id="element-2329" data-mp="9n3zz0ftjvhh">Preview access password: password</p>
            </div>
            {error && <p className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" role="alert" data-id="element-2330" data-mp="xbeullux8yxb">
                {error}
              </p>}
            <button type="submit" className="group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-forest px-5 py-3.5 text-sm font-semibold text-cream transition-colors hover:bg-forest-dark" data-id="element-2331" data-mp="39pcjjig0y6yv">
              Sign in
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-2332" data-mp="2vos2aqprcj7h" />
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-ink/55" data-id="element-2333" data-mp="3sdhhg9a02xpr">
            New to ManyCo?{' '}
            <Link to="/" className="font-medium text-forest hover:underline" data-id="element-2334" data-mp="3odh4kt2juukt">
              Get an inventory recovery estimate
            </Link>
          </p>
        </section>
      </div>
    </main>;
}